import './styles/main.scss'
import themeConfig from './styles/config'

const exportedObjects = {...themeConfig}
export default exportedObjects;